module.exports = __webpack_public_path__ + "2e121940365331d764285dd2e5313591.svg";